import React from 'react';
import { MenuItem } from "@mui/material";
import SortSelect from "../sortSelect/SortSelect";
import { SortDirType } from "../../../../types/common/SortDirType";
import { SortParams } from "../../../../types/common/SortParams";

type BoundSortSelectProps<T, U> = {
  query?: T;
  defaultSortBy: U;
  defaultSortDir: SortDirType;
  sortByFields: Array<{ value: U; label: string }>;
  onChange: (newQuery: T) => void;
}

const BoundSortSelect = <T extends SortParams, U extends string>({
  query,
  defaultSortBy,
  defaultSortDir,
  sortByFields,
  onChange
}: BoundSortSelectProps<T, U>) => {

  const onSortByChange = (value: U) => {
    onChange({
      sortBy: value
    } as unknown as T);
  }

  const onSortDirChange = (value: SortDirType) => {
    onChange({
      sortDir: value
    } as unknown as T);
  }

  return <SortSelect<U>
      sortBy={(query?.sortBy || defaultSortBy) as U}
      sortDir={query?.sortDir || defaultSortDir}
      onSortByChange={onSortByChange}
      onSortDirChange={onSortDirChange}
      label={'Sort By'}
    >
      {
        sortByFields.map((field, index) => (
          <MenuItem
            key={index}
            value={field.value}
          >
            {field.label}
          </MenuItem>
        ))
      }
    </SortSelect>
}

export { BoundSortSelect };